import { DOCUMENT_CLIENT_PARAM, documentDeepLink } from "../../../lib/documentDeepLink.ts";
import type { QuinnDocumentSource } from "../types";

export function documentSourceHref(document: QuinnDocumentSource): string | null {
    if (!document.document_id || !document.business_id) {
        return null;
    }
    return documentDeepLink(document.document_id, document.business_id);
}

export function documentSourceCounterparty(document: QuinnDocumentSource): string | null {
    return document.counterparty || document.scanned_fields?.seller_name || null;
}

export function documentSourceDate(document: QuinnDocumentSource): string | null {
    return (
        document.document_date ||
        document.scanned_fields?.normalized_datetime ||
        document.scanned_fields?.date ||
        null
    );
}

const DOCUMENT_LINK_SCHEME = "doc:";

export const QUINN_DOCUMENT_DRAWER_LAYER = "relative z-[60]";

export type QuinnDocumentLinkTarget = {
    documentId: string;
    businessId: string;
};

export function isQuinnDocumentHref(href: unknown): href is string {
    return typeof href === "string" && href.startsWith(DOCUMENT_LINK_SCHEME);
}

export function parseQuinnDocumentLink(href: unknown): QuinnDocumentLinkTarget | null {
    if (!isQuinnDocumentHref(href)) return null;
    const [documentId, query = ""] = href.slice(DOCUMENT_LINK_SCHEME.length).split("?", 2);
    const businessId = new URLSearchParams(query).get(DOCUMENT_CLIENT_PARAM);
    return documentId && businessId ? { documentId, businessId } : null;
}
